export const group = {
  modal: {
    remove: {
      content: `Вы действительно хотите удалить группу <b>{name}<b>?`
    },
    add_contact_method: {
      description: `
            Создать новый контакт метод вы сможете в разделе <a href="/pbx/operators/contacts" target="_blank">Контакты</a>
          `
    },
    add_time: {
      description: `
            Добавить новые можно в разделе <a href="/pbx/time-conditions" target="_blank">Расписания</a>, после чего они станут доступны для выбора.
          `
    }
  },

  form: {
    title: {
      edit: 'Название группы'
    },

    field: {
      name: 'Имя',
      work_time: 'Рабочее время'
    },

    button: {
      add_time: 'Выбрать расписание',
      add_contact_method: 'Выбрать контакт метод'
    }
  }
};
